import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'profile-setup',
    templateUrl: './profilesetting.component.html',
   // styleUrls: ['./profile-setup.component.scss']
})
export class ProfileSetupComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}
